import React from 'react'
import Layout from '../components/Layout'
import { DocumentMagnifyingGlassIcon } from '@heroicons/react/24/outline'

const AuditorsPortal: React.FC = () => {
  return (
    <Layout portalType="auditors">
      <div className="py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-8">Auditors Portal</h1>
          <div className="bg-white rounded-lg shadow p-8 text-center">
            <DocumentMagnifyingGlassIcon className="h-12 w-12 text-purple-600 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">Independent Audit Dashboard</h3>
            <p className="text-gray-600">Access compliance reports and read-only audit logs for verification.</p>
            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-purple-50 p-4 rounded-lg">
                <h4 className="font-medium text-purple-900">Audit Dashboard</h4>
                <p className="text-sm text-purple-700 mt-1">Comprehensive audit tools and reporting</p>
              </div>
              <div className="bg-purple-50 p-4 rounded-lg">
                <h4 className="font-medium text-purple-900">Compliance Reports</h4>
                <p className="text-sm text-purple-700 mt-1">Detailed compliance verification reports</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default AuditorsPortal
